/* Common page layout for fe-build/server */
import React from 'react';
import PropTypes from 'prop-types';
import { HelmetProvider } from 'react-helmet-async';
import AllhomesApi, {
  AllhomesApiProvider,
} from '@domain-group/fe-co-allhomes-api';
import { withMediaQueryProvider } from '@domain-group/fe-allhomes-library';
import Header from '@domain-group/fe-co-allhomes-header';
import Footer from '@domain-group/fe-co-allhomes-footer';
import EmotionWrapper from './emotion-wrapper.js';

const WrappedProvider = withMediaQueryProvider(AllhomesApiProvider);

const StandardPage = ({
  component: Component,
  header: headerOrig,
  footer,
  body,
  device,
  apolloClient,
  helmetContext,
}) => {
  const {
    isEuUser,
    endpoints,
    absoluteUrlBase,
    toggledFeatures,
    activeExperiments,
    initialAuthState,
    initialUsername,
    authToken,
    pageContext,
    ...header
  } = headerOrig;

  const apiProps = {
    device,
    isEuUser,
    endpoints,
    absoluteUrlBase,
    toggledFeatures,
    activeExperiments,
    initialAuthState,
    initialUsername,
    authToken,
    apolloClient,
    pageContext,
  };

  return (
    <EmotionWrapper>
      <HelmetProvider context={helmetContext}>
        <WrappedProvider {...apiProps}>
          <AllhomesApi>
            {({ pageContext: currentPageContext = {} }) => (
              <React.Fragment>
                <Header
                  {...header}
                  showMediaBanner
                  activeNavItem={
                    (currentPageContext['fe-co-allhomes-header'] || {})
                      .activeNavItem
                  }
                />
                <Component {...body} device={device} />
                <Footer {...footer} device={device} />
              </React.Fragment>
            )}
          </AllhomesApi>
        </WrappedProvider>
      </HelmetProvider>
    </EmotionWrapper>
  );
};

StandardPage.propTypes = {
  header: PropTypes.shape({
    isEuUser: PropTypes.bool,
    absoluteUrlBase: PropTypes.string,
    toggledFeatures: PropTypes.shape({}),
    activeExperiments: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        variant: PropTypes.string,
      }),
    ),
    endpoints: PropTypes.shape({}),
    initialAuthState: PropTypes.string,
    initialUsername: PropTypes.string,
    authToken: PropTypes.string.isRequired,
    pageContext: PropTypes.objectOf(PropTypes.shape({})),
  }).isRequired,
  footer: PropTypes.shape({}).isRequired,
  body: PropTypes.shape({}).isRequired,
  component: PropTypes.func.isRequired,
  device: PropTypes.string,
  apolloClient: PropTypes.shape({}),
  helmetContext: PropTypes.shape({}),
};

StandardPage.defaultProps = {
  device: 'mobile',
  apolloClient: undefined,
  helmetContext: {},
};

export default StandardPage;
